/*----------------------------------------------- --- DEVELOP URLS START ------------------------------------------------------------------------------------- */

export const BASE_URL = "https://api.test.nidhi.apcfss.in/"
export const LOGIN_API_BASE_URL = BASE_URL + "login/"
export const MASTER_API_BASE_URL = BASE_URL + "master/"
export const PAYROLL_API_BASE_URL = BASE_URL + "hrms/"
export const HRMS_API_BASE_URL = BASE_URL + "hrms2/"

/* LOGIN UI URLS IN DEVELOP BRANCH*/
export const LOGIN_PAGE_URL = 'https://test.nidhi.apcfss.in/login';
export const LOGIN_DOMAIN = 'https://test.nidhi.apcfss.in';

export const LOGIN_API_UPDATED = 'https://api.test.nidhi.apcfss.in/loginV2/'


/* HERB Modules UI URLS IN DEVELOP */

export const BUDGET_UI_URL = 'https://budget.test.nidhi.apcfss.in';

export const APZPF_UI_URL = "https://zpgpf.test.nidhi.apcfss.in";

export const APGLI_UI_URL = 'https://apgli.test.nidhi.apcfss.in';

export const AIS_UI_URL = 'https://ais.test.nidhi.apcfss.in';

export const BUDGET_PLANNING_UI_URL = "https://budgetplanning.test.nidhi.apcfss.in"

export const CORPORATION_UI_URL = "https://corp.test.nidhi.apcfss.in"

export const CONTRACT_UI_URL = "https://contract.test.nidhi.apcfss.in"

export const DCM_UI_URL = "https://cdm.test.nidhi.apcfss.in"

export const DASHBOARD_UI_URL = "https://dashboard.test.nidhi.apcfss.in"

export const ESR_UI_URL = "https://esr.test.nidhi.apcfss.in"

export const ESS_UI_URL = "https://ess.test.nidhi.apcfss.in"

export const EXPENDITURE_UI_URL = 'https://expenditures.test.nidhi.apcfss.in';

export const GPS_UI_URL = 'https://gps.test.nidhi.apcfss.in';

export const GCINFO_UI_URL = 'https://gcinfo.test.nidhi.apcfss.in';

export const GOIR_UI_URL = 'https://apgoir.test.nidhi.apcfss.in';

export const HRMS_UI_URL = 'https://hrms.test.nidhi.apcfss.in';

export const HR_ACTION_UI_URL = 'https://hractions.test.nidhi.apcfss.in';

export const PAYROLL_UI_URL = 'https://payroll.test.nidhi.apcfss.in';

export const PAYROLL_NIDHI_UI_URL = 'https://paybills.test.nidhi.apcfss.in';


export const PENSIONS_UI_URL = 'https://ops.test.nidhi.apcfss.in';

export const WORKS_UI_URL = 'https://works.test.nidhi.apcfss.in'

export const PFMS_UI_URL = 'https://pfms.test.nidhi.apcfss.in'

export const SRTS_UI_URL = 'https://srts.test.nidhi.apcfss.in'

export const ADMIN_UI_URL = 'https://admin.test.nidhi.apcfss.in'

export const GAD_UI_URL = 'https://gad.test.nidhi.apcfss.in'

export const EVIGIL_UI_URL = 'https://evigil.test.nidhi.apcfss.in'

export const CASHLESS_PAYMENTS_URL = 'https://cltp.test.nidhi.apcfss.in'

// export const MR_UI_URL = 'https://drntrvaidyasevamr.test.nidhi.apcfss.in'

export const MR_UI_URL = 'https://cltp.test.nidhi.apcfss.in'

export const PO2025_UI_URL = "https://po2025.test.nidhi.apcfss.in"
 


/* Other COMMON  URLS */
export const LOGIN_CHECK = LOGIN_API_BASE_URL + "loginCheck"

export const CITIZEN_BILL_STATUS_URL = EXPENDITURE_UI_URL + '/citizenbillstatus';

export const CHANGE_PASSWORD_UI_URL = LOGIN_DOMAIN + "/changePassword";

export const SRConfirmation = PAYROLL_UI_URL + "/srConfirmation";

export const TIMEZONE_REDIRECTION_URL = "https://support.yondo.com/hc/en-us/articles/206597867-How-do-I-change-my-computer-time-zone-settings-"

export const AUTHENTICATION_URL = LOGIN_API_BASE_URL + "authenticate";



export const USER_VERIFICATION_OTP = LOGIN_API_BASE_URL + "getAadharOTPByLoginId";

export const LOGIN_AUTHENTICATION_URL = LOGIN_API_BASE_URL + "loginOTPVerification";

export const LOGIN_AUTHENTICATION_URL_TOTP = LOGIN_API_BASE_URL + "loginOTPVerificationTOTP";

export const SIGN_IN_URL = LOGIN_API_BASE_URL + 'authenticator'

export const TOKEN_INVALIDATE_URL = LOGIN_API_BASE_URL + 'logout'

export const GENERATE_OTP_URL = LOGIN_API_BASE_URL + "generateotp"

export const VERIFY_OTP_URL = LOGIN_API_BASE_URL + "verifyotp";

export const SERVICES_URL = LOGIN_API_BASE_URL + "serviceslist";

export const EMPLOYEE_COUNT = PAYROLL_API_BASE_URL + "srcertification/get/employeescount"

export const GET_DETAILS_BY_AADHAR_DOB = LOGIN_API_BASE_URL + "getLoginDetails"

export const GET_RETIRING_EMP_COUNT = PAYROLL_API_BASE_URL + "getRetiringEmpsCountInDDo"

// Service Association Urls
export const ServiceAssociation = HRMS_API_BASE_URL + "save/serviceAssociationRegistration"

export const PAYROLL_FILE_UPLOAD_URL = BASE_URL + "dms/payroll/upload";

export const DropdownList = HRMS_API_BASE_URL + "getSecretariats";

export const OTpforServiceAssociation = HRMS_API_BASE_URL + "sentOtpForServiceAssociation"

export const AWS_DOWNLOAD_URL ="https://api.test.nidhi.apcfss.in/dms/api/presigned-url?path="

export const chatwidgeturl = LOGIN_API_BASE_URL+"aiAssistance";

export const DMS_API_URL = 'https://api.test.nidhi.apcfss.in/dms/';

export const FILE_DOWNLOAD_URL = DMS_API_URL + "payroll/download/";

export const FILE_DOWNLOAD_URL_PO = DMS_API_URL+"api/presigned-url?path=hrms/";

export const AWS_DOWNLOAD_URL_PO =DMS_API_URL+"v2/api/presigned-url?path=hrms/"

export const ESS_DOMAIN = "https://ess2.test.nidhi.apcfss.in"

export const HCM_UI_URL="https://hcm.test.nidhi.apcfss.in"








/*----------------------------------------------- --- DEVELOP URLS END ------------------------------------------------------------------------------------- */

